export function subscribePribta21QueueDetail (options) {
  const firebase = options && options.firebase
  const shopId = options && options.shopId
  const masBranchID = options && options.masBranchID
  const bookNo = options && options.bookNo
  const onEvent = options && options.onEvent
  const onError = options && options.onError
  const debounceMs = Number(options && options.debounceMs) || 300

  if (!firebase || !firebase.firestore || !shopId || !masBranchID || !bookNo) {
    return function () {}
  }

  let initialized = false
  let lastVersion = 0
  let debounceTimer = null
  let isStopped = false
  const docRef = firebase.firestore()
    .collection('Pribta21QueueRealtime')
    .doc(String(shopId))
    .collection('branches')
    .doc(String(masBranchID))

  const unsubscribe = docRef.onSnapshot(snapshot => {
    if (isStopped) return
    if (!snapshot.exists) return

    const event = snapshot.data() || {}
    const version = Number(event.version) || 0
    if (!initialized) {
      initialized = true
      lastVersion = version
      return
    }
    if (version <= lastVersion) return
    lastVersion = version
    if (event.bookNo && String(event.bookNo) !== String(bookNo)) return

    if (debounceTimer) clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => {
      debounceTimer = null
      if (!isStopped && typeof onEvent === 'function') onEvent(event)
    }, debounceMs)
  }, error => {
    if (!isStopped && typeof onError === 'function') onError(error)
  })

  return function stopPribta21QueueDetail () {
    isStopped = true
    if (debounceTimer) clearTimeout(debounceTimer)
    debounceTimer = null
    if (typeof unsubscribe === 'function') unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/services/pribta21Realtime.js